<script lang="ts">
	import { goto } from '$app/navigation';
	import { t, Verbiage } from '@infinitro/content';
	import { toSiteUrl } from '@infinitro/global';

	export let imgUrl: string;
	export let title: Verbiage;
	export let description: Verbiage;
	export let buttonText: Verbiage;
	export let link: string;
	export let variant: 'card1' | 'card2' = 'card1';

	const clickIt = () => {
		goto(toSiteUrl(link));
	};
</script>

<!-- Desktop -->
<div class="card-desktop variant-{variant}">
	<div class="card-desktop-content">
		<div class="card-desktop-text">
			<div class="card-desktop-title">{$t(title)}</div>
			<div class="card-desktop-desc">
				{$t(description)}
			</div>
		</div>
		<button class="card-desktop-btn" on:click={clickIt}>
			<div class="card-desktop-btn-text">{$t(buttonText)}</div>
		</button>
	</div>
	<img class="card-desktop-img" src={imgUrl} alt="" />
</div>

<!-- Mobile -->
<button class="card-mobile variant-{variant}" on:click={clickIt}>
	<div class="card-mobile-content">
		<div class="card-mobile-title">{$t(title)}</div>
		<div class="card-mobile-desc">
			{$t(description)}
		</div>
		<div class="card-mobile-btn">{$t(buttonText)}</div>
	</div>
	<img class="card-mobile-img" src={imgUrl} alt="" />
</button>

<style>
	.card-desktop {
		position: relative;
		display: none;
		height: 205px;
		width: 100%;
		border-radius: 1rem;
}
	@media (min-width: 768px) {
		.card-desktop {
				display: flex;
				flex-direction: column;
		}
}

	.card-desktop-content {
		position: absolute;
		left: 32px;
		top: 36px;
		display: inline-flex;
		width: 297px;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		gap: 0.75rem;
}

	.card-desktop-text {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		gap: 0.25rem;
		align-self: stretch;
}

	.card-desktop-title {
		justify-content: flex-start;
		align-self: stretch;
		font-size: 1.5rem;
		line-height: 2rem;
		font-weight: 700;
		line-height: 26px;
}

	.card-desktop-desc {
		justify-content: flex-start;
		align-self: stretch;
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: 500;
		line-height: 22px;
		opacity: 0.7;
}

	.card-desktop-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 0.5rem;
		border-radius: 0.75rem;
		padding: 1rem;
}

	.card-desktop-btn-text {
		justify-content: flex-start;
		font-size: 0.875rem;
		font-weight: 600;
		line-height: 1rem;
}

	.card-desktop-img {
		position: absolute;
		bottom: 0px;
		right: 0px;
		height: 280px;
		width: auto;
		--tw-translate-y: 2rem;
		--tw-translate-x: 1rem;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

	.card-mobile {
		position: relative;
		height: 234px;
		width: 100%;
		overflow: hidden;
		border-radius: 1rem;
		text-align: left;
}

	@media not all and (min-width: 768px) {
		.card-mobile {
				display: inline-flex;
		}
}

	@media (min-width: 768px) {
		.card-mobile {
				display: none;
		}
}

	.card-mobile-content {
		position: absolute;
		left: 20px;
		top: 20px;
		z-index: 10;
		display: inline-flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		gap: 0.25rem;
}

	.card-mobile-title {
		font-size: 1.5rem;
		line-height: 2rem;
		font-weight: 700;
		line-height: 26px;
}

	.card-mobile-desc {
		font-size: 1rem;
		line-height: 1.5rem;
		font-weight: 500;
		line-height: 22px;
		opacity: 0.7;
}

	.card-mobile-btn {
		margin-top: 0.75rem;
		border-radius: 0.75rem;
		padding-left: 1rem;
		padding-right: 1rem;
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
		font-size: 0.875rem;
		font-weight: 600;
		line-height: 1rem;
}

	.card-mobile-img {
		position: absolute;
		right: 0px;
		bottom: 0px;
		height: 234px;
		width: auto;
		border-bottom-right-radius: 1rem;
		-o-object-fit: contain;
		   object-fit: contain;
}

	/* Card 1 styles (Casino - light gradient, black text) */
	.variant-card1 {
		background: linear-gradient(
			to bottom right,
			var(--component-casino-slots-banner-card1-bg-from),
			var(--component-casino-slots-banner-card1-bg-to)
		);
	}

	.variant-card1 .card-desktop-title,
	.variant-card1 .card-mobile-title {
		color: var(--component-casino-slots-banner-card1-title-color, #000000);
	}

	.variant-card1 .card-desktop-desc,
	.variant-card1 .card-mobile-desc {
		color: var(--component-casino-slots-banner-card1-desc-color, #000000);
	}

	.variant-card1 .card-desktop-btn,
	.variant-card1 .card-mobile-btn {
		background: var(--component-casino-slots-banner-card1-btn-bg, #ffffff);
	}

	.variant-card1 .card-desktop-btn-text,
	.variant-card1 .card-mobile-btn {
		color: var(--component-casino-slots-banner-card1-btn-text, #000000);
	}

	/* Card 2 styles (Slots - dark gradient, white text, custom button) */
	.variant-card2 {
		background: linear-gradient(
			to left,
			var(--component-casino-slots-banner-card2-bg-from),
			var(--component-casino-slots-banner-card2-bg-to)
		);
	}

	.variant-card2 .card-desktop-title,
	.variant-card2 .card-mobile-title {
		color: var(--component-casino-slots-banner-card2-title-color, #ffffff);
	}

	.variant-card2 .card-desktop-desc,
	.variant-card2 .card-mobile-desc {
		color: var(--component-casino-slots-banner-card2-desc-color, #ffffff);
	}

	.variant-card2 .card-desktop-btn,
	.variant-card2 .card-mobile-btn {
		background: var(--component-casino-slots-banner-card2-btn-bg, #ffffff);
	}

	.variant-card2 .card-desktop-btn-text,
	.variant-card2 .card-mobile-btn {
		color: var(--component-casino-slots-banner-card2-btn-text, #ad2941);
	}
</style>
